import React, { useContext } from 'react';
import { Context } from '../Reward';
import LogoKeno from '../../../../assets/img/logo-keno.png';
import LogoMega from '../../../../assets/img/logo-mega.png';
import LogoPower from '../../../../assets/img/logo-power.png';
import LogoMax3d from '../../../../assets/img/logo-max3d.png';
import LogoMax3dPro from '../../../../assets/img/logo-max3dpro.png';
import LogoLotto535 from '../../../../assets/img/logo-lotto535.png';

const logos = { keno: LogoKeno, mega: LogoMega, power: LogoPower, max3d: LogoMax3d, max3dpro: LogoMax3dPro, lotto535: LogoLotto535 };
const supportedGames = ['keno', 'mega', 'power', 'max3d', 'max3dpro', 'lotto535'];
const countLabel = count => `${Number(count || 0).toLocaleString('vi-VN')} vé`;

export default function GameQuickFilter({ loading }) {
  const { state, dispatch } = useContext(Context);
  const counts = state.summary.games || {};
  const knownGames = supportedGames.map(id => state.games.find(game => game.id === id) || { id, name: id });
  const visibleGames = knownGames.filter(game => state.filter.gameScope === 'keno' ? game.id === 'keno' : game.id !== 'keno');
  const total = visibleGames.reduce((sum, game) => sum + Number(counts[game.id] || 0), 0);

  return (
    <div className="reward-game-counts" role="group" aria-label="Lọc nhanh theo trò chơi" aria-busy={loading}>
      {state.filter.gameScope === 'other' && (
        <button
          type="button"
          className={`reward-game-count${state.filter.gameId === '' ? ' active' : ''}`}
          aria-pressed={state.filter.gameId === ''}
          disabled={loading}
          onClick={() => {
            if (state.filter.gameId !== '') dispatch({ type: 'SUBMIT_FILTER', payload: { gameId: '' } });
          }}
        >
          <span>Tất cả</span><strong>{loading ? '…' : countLabel(total)}</strong>
        </button>
      )}
      {visibleGames.map(game => {
        const active = state.filter.gameScope === 'keno' || state.filter.gameId === game.id;
        return (
          <button
            type="button"
            key={game.id}
            className={`reward-game-count${active ? ' active' : ''}`}
            aria-label={`Lọc ${game.name}`}
            aria-pressed={active}
            disabled={loading || state.filter.gameScope === 'keno'}
            onClick={() => {
              if (state.filter.gameScope === 'other' && state.filter.gameId !== game.id) {
                dispatch({ type: 'SUBMIT_FILTER', payload: { gameId: game.id } });
              }
            }}
          >
            {logos[game.id] ? <img src={logos[game.id]} alt={game.name} title={game.name} /> : <span>{game.name}</span>}
            <strong>{loading ? '…' : countLabel(counts[game.id])}</strong>
          </button>
        );
      })}
    </div>
  );
}
